/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

export const KillswitchListStatus = {
  Active: "active",
  Scheduled: "scheduled",
  Expired: "expired",
  Lifted: "lifted",
} as const;
export type KillswitchListStatus = ClosedEnum<typeof KillswitchListStatus>;

/** @internal */
export const KillswitchListStatus$outboundSchema: z.ZodMiniEnum<
  typeof KillswitchListStatus
> = z.enum(KillswitchListStatus);
